import request from "./request";
import apis from "./apis";

const {
  leaveInfo,
} = apis.leave;

const leave = {
  getLeaveInfo: (data: Object) => {
    return request.get(leaveInfo, data);
  },
  deleteLeaveInfo: (data: Object) => {
    return request.delete(leaveInfo, data);
  },
  updateLeaveInfo: (data: Object) => {
    return request.put(leaveInfo, data);
  },
  createLeaveInfo: (data: Object) => {
    return request.post(leaveInfo, data);
  },
};

export default leave;